<template>
  <div class="canpay-header-div">
    <div class="row canpay-header">
      <div class="col-1 align-self-center ham-right-fix">
        <div class="float-right">
          <svg
            v-if="showicon === 'arrowback'"
            @click="clickBack"
            version="1.1"
            id="Layer_1"
            class="back-svg-icon"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            height="40"
            width="40"
            style="
              enable-background: new 0 0 100 100;
              fill: none;
              stroke: #000000;
              stroke-width: 6;
              stroke-miterlimit: 10;
            "
            xml:space="preserve"
          >
            <polyline class="st0" points="52.1,87.5 14.6,50 52.1,12.5 " />
            <line class="st0" x1="91.7" y1="50" x2="14.6" y2="50" />
          </svg>
          <a class="hamburger-icons" href="javascript:void(0)" @click="showDrawer">
            <i
              v-if="showicon === 'hamburger'"
              class="fa fa-2x fa-bars icon menuicon-header-style"
              style="color: #000000; background-color: #ffffff !important"
              aria-hidden="true"
            ></i>
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              v-if="showicon === 'close'"
              viewBox="0 0 14 14"
              style="enable-background: new 0 0 14 14"
              xml:space="preserve"
              height="20"
              width="20"
            >
              <g>
                <g>
                  <path
                    d="M1,14c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l12-12c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-12,12C1.5,13.9,1.3,14,1,14z"
                  />
                </g>
                <g>
                  <path
                    d="M13,14c-0.3,0-0.5-0.1-0.7-0.3l-12-12c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l12,12c0.4,0.4,0.4,1,0,1.4
			C13.5,13.9,13.3,14,13,14z"
                  />
                </g>
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div class="col-3 align-self-center">
        <div>
          <a v-on:click="cancelTransaction()">
            <img
              src="../../../assets/images/canpay-logo-1.png"
              class="canpay-logo"
            />
          </a>
          <button
            v-if="show_sign_out"
            type="button"
            class="btn btn-sign-out btn-shadow-btn-black"
            @click="logout()"
          >
            <label class="ok-button-style">Sign Out</label>
          </button>
        </div>
      </div>
      <div class="col-7 align-self-center">
        <div class="float-right">
          <div class="row header-margin-top">
            <span style="float: left">
              <!-- <svg
                version="1.1"
                id="Layer_1"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="13"
                height="13"
                viewBox="0 0 93 86.9"
                style="enable-background: new 0 0 93 86.9"
                xml:space="preserve"
              >
                <path
                  d="M33.9,0c-3.2-0.1-5.8,1.4-6.1,3.5l-2.3,15.3l-15.5,0c-2.5,0-4.5,3.1-4.5,6.9s2,6.9,4.5,6.9l13.4,0L20,54.3l-15.5,0
	C2,54.3,0,57.4,0,61.2c0,3.8,2,6.9,4.5,6.9l13.3,0l-2,13.2c-0.4,2.5,2.4,4.9,6.2,5.5c3.8,0.6,7.1-0.9,7.5-3.4l2.3-15.3l21.8,0
	l-2,13.2c-0.4,2.5,2.4,4.9,6.2,5.5c3.8,0.6,7.1-0.9,7.5-3.4L67.7,68l15.5,0c2.5,0,4.5-3.1,4.5-6.9c0-3.8-2-6.9-4.5-6.9l-13.4,0
	l3.3-21.5l15.5,0c2.5,0,4.5-3.1,4.5-6.9s-2-6.9-4.5-6.9l-13.3,0l2-13.2c0.4-2.5-2.4-4.9-6.2-5.5c-3.8-0.6-7.1,0.9-7.5,3.4l-2.3,15.3
	l-21.8,0l2-13.2c0.4-2.5-2.4-4.9-6.2-5.5C34.8,0.1,34.3,0,33.9,0L33.9,0z M59.1,32.7l-3.3,21.5l-21.8,0l3.3-21.5
	C37.3,32.7,59.1,32.7,59.1,32.7z"
                />
              </svg> -->
              <span>
                <i
                  class="icon2-noun-hashtag-small align-middle"
                  aria-hidden="true"
                ></i>
              </span>
              <label class="terminal-ID-Demo-Mode">Terminal ID:</label>
              <label class="terminal-ID-Demo-Mode-text">{{
                terminalName
              }}</label>
            </span>
          </div>
          <div class="row header-margin-top">
            <span style="float: left">
              <!-- <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="13"
                height="13"
                viewBox="0 0 47.9 47.8"
                style="enable-background: new 0 0 47.9 47.8"
                xml:space="preserve"
              >
                <path
                  d="M33.8,47.8c-1.3,0-2.7-0.2-4.3-0.7c-4.8-1.5-10.4-5.4-16.9-11.9C0.1,22.5-3.2,13,3,6.8c4.7-4.7,8.2-6.5,8.4-6.5
	c1-0.5,2.2-0.3,3,0.6l8.3,9.3c0.7,0.8,0.8,2,0.3,2.9l-3.4,5.7c0.6,1,1.8,2.9,4.2,5.3c2.4,2.4,4.3,3.6,5.3,4.2l5.7-3.5
	c0.9-0.6,2.1-0.4,2.9,0.3l9.3,8.3c0.8,0.8,1.1,2,0.6,3c-0.1,0.1-1.9,3.7-6.5,8.4C39.6,46.3,37.2,47.8,33.8,47.8z M12,5.7
	C10.7,6.6,8.8,8,6.5,10.3c-5.1,5.1,3.9,15.5,9.7,21.3c5.9,5.9,10.9,9.5,14.9,10.7c3.7,1.2,5.5,0,6.5-1.1c2.3-2.3,3.7-4.2,4.6-5.5
	l-6.4-5.6l-5.2,3.1c-0.6,0.4-1.3,0.4-2,0.2c-0.4-0.1-3.7-1.2-8.3-5.8l0,0c-4.6-4.6-5.7-7.9-5.8-8.3c-0.2-0.7-0.1-1.4,0.2-2l3.1-5.2
	L12,5.7z"
                />
              </svg> -->
              <span>
                <i
                  class="icon2-support-small align-middle"
                  aria-hidden="true"
                ></i>
              </span>
              <label class="terminal-ID-Demo-Mode">Merchant Support:</label>
              <label class="terminal-ID-Demo-Mode-text">1-888-395-4992</label>
            </span>
          </div>
          <div class="row header-margin-top">
            <span style="float: left">
              <!-- <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="13"
                height="13"
                viewBox="0 0 47.9 47.8"
                style="enable-background: new 0 0 47.9 47.8"
                xml:space="preserve"
              >
                <path
                  d="M33.8,47.8c-1.3,0-2.7-0.2-4.3-0.7c-4.8-1.5-10.4-5.4-16.9-11.9C0.1,22.5-3.2,13,3,6.8c4.7-4.7,8.2-6.5,8.4-6.5
	c1-0.5,2.2-0.3,3,0.6l8.3,9.3c0.7,0.8,0.8,2,0.3,2.9l-3.4,5.7c0.6,1,1.8,2.9,4.2,5.3c2.4,2.4,4.3,3.6,5.3,4.2l5.7-3.5
	c0.9-0.6,2.1-0.4,2.9,0.3l9.3,8.3c0.8,0.8,1.1,2,0.6,3c-0.1,0.1-1.9,3.7-6.5,8.4C39.6,46.3,37.2,47.8,33.8,47.8z M12,5.7
	C10.7,6.6,8.8,8,6.5,10.3c-5.1,5.1,3.9,15.5,9.7,21.3c5.9,5.9,10.9,9.5,14.9,10.7c3.7,1.2,5.5,0,6.5-1.1c2.3-2.3,3.7-4.2,4.6-5.5
	l-6.4-5.6l-5.2,3.1c-0.6,0.4-1.3,0.4-2,0.2c-0.4-0.1-3.7-1.2-8.3-5.8l0,0c-4.6-4.6-5.7-7.9-5.8-8.3c-0.2-0.7-0.1-1.4,0.2-2l3.1-5.2
	L12,5.7z"
                />
              </svg> -->
              <span>
                <i
                  class="icon2-support-small align-middle"
                  aria-hidden="true"
                ></i>
              </span>
              <label class="terminal-ID-Demo-Mode">Consumer Support:</label>
              <label class="terminal-ID-Demo-Mode-text">1-877-567-5174</label>
            </span>
          </div>
        </div>
      </div>
      <!-- header notification section -->
      <div class="col-1 align-self-center remove-padding-res make-icon-top">
        <div class="bell-icon-div float-left">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 125"
            style="enable-background: new 0 0 100 125"
            xml:space="preserve"
            @click="showNotifModal()"
            height="30"
            width="30"
          >
            <g>
              <path
                d="M89.2,61.1c0-0.1-3.8-5.1-3.8-20.7c0-19.5-15.8-35.3-35.3-35.3S14.6,20.9,14.6,40.4c0,15.7-3.3,19.9-3.3,20.1
		c-1,0.7-1.4,1.7-1.4,2.8v17.1c0,1.9,1.6,3.6,3.6,3.6h22.8c1.6,6.2,7,10.9,13.8,10.9s12-4.7,13.7-10.9h22.8c2,0,3.6-1.7,3.6-3.6v-17
		C90.1,62.5,89.8,61.7,89.2,61.1z M50,87.8c-2.7,0-5-1.5-6.3-3.7h12.6C55,86.2,52.7,87.8,50,87.8z M83,76.9H17V64.7
		c1.9-2.7,4.7-9.1,4.7-24.2C21.7,25,34.4,12.3,50,12.3c15.5,0,28.2,12.7,28.2,28.2c0,14.4,3.1,21.4,4.7,24.1v12.3H83z"
              />
            </g>
          </svg>
          <div class="notification-count-area" v-if="notification_count != 0">
            <span class="notif-count">{{ notification_count }}</span>
          </div>
        </div>
      </div>
      <!-- Global Notification modal start -->
      <b-modal
        id="notif-modal"
        ref="notif-modal"
        hide-header
        hide-footer
        no-close-on-backdrop
        scrollable
        size="lg"
      >
        <!-- notification list section start -->
        <div v-if="!showNotifBody">
          <div class="row header-info">
            <div class="col-3">
              <span class="store-access-label">Notifications</span>
            </div>
            <div class="col-9">
              <div class="count-pos">
                <div class="notif-count-circle" v-if="notification_count!=0">
                  <span class="notif-count-modal">{{
                    notification_count
                  }}</span>
                </div>
              </div>
              <div @click="hideNotifModal()" class="modal-cross">
                <i class="fa fa-times" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div class="header-info">
            <div
              class="row notif-pad"
              v-for="(item, index) in notifications"
              :key="item.id"
              @click="showNotifDetails(item)"
            > 
              <div class="col-12" v-bind:class="[item.is_read == 0 ? 'notification_unread_cls' : 'notification_read_cls']" :for="item.id">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 100 125"
                  style="enable-background: new 0 0 100 125"
                  xml:space="preserve"
                  height="30"
                  width="30"
                  class="margin-t-5"
                  v-bind:fill="[item.is_read == 0 ? '#E05F5F' : '#000000']"
                >
                  <g>
                    <path
                      d="M89.2,61.1c0-0.1-3.8-5.1-3.8-20.7c0-19.5-15.8-35.3-35.3-35.3S14.6,20.9,14.6,40.4c0,15.7-3.3,19.9-3.3,20.1
		c-1,0.7-1.4,1.7-1.4,2.8v17.1c0,1.9,1.6,3.6,3.6,3.6h22.8c1.6,6.2,7,10.9,13.8,10.9s12-4.7,13.7-10.9h22.8c2,0,3.6-1.7,3.6-3.6v-17
		C90.1,62.5,89.8,61.7,89.2,61.1z M50,87.8c-2.7,0-5-1.5-6.3-3.7h12.6C55,86.2,52.7,87.8,50,87.8z M83,76.9H17V64.7
		c1.9-2.7,4.7-9.1,4.7-24.2C21.7,25,34.4,12.3,50,12.3c15.5,0,28.2,12.7,28.2,28.2c0,14.4,3.1,21.4,4.7,24.1v12.3H83z"
                    />
                  </g>
                </svg>
                <span class="notif-title">{{ item.title }}</span>
                <span>
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 2540 3175"
                    style="
                      enable-background: new 0 0 2540 3175;
                      -webkit-transform: scaleX(-1);
                      transform: scaleX(-1);
                      float: right;
                      margin-top: 22px;
                    "
                    xml:space="preserve"
                    height="15"
                    width="15"
                    fill="#7f7f7f"
                  >
                    <g>
                      <path
                        d="M1878,2270c39,39,39,104,0,143c-40,40-104,40-144,0L662,1342c-39-40-39-104,0-144L1734,127c40-40,104-40,144,0
		c39,39,39,104,0,143L878,1270L1878,2270z"
                      />
                    </g>
                  </svg>
                </span>
                <br />
                <span class="notif-time">{{
                  getNotifDateFormat(item.created_at)
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- notification list section end -->
        <!-- notification body section start -->
        <div v-else>
          <!-- notification title -->
          <div class="row mb-4">
            <div class="col-12">
              <span class="store-access-label">
                <i
                  class="fa fa-arrow-left"
                  aria-hidden="true"
                  @click="showAllNotifications"
                ></i
                ><span class="notif-title-label">{{
                  currentNotif.title
                }}</span></span
              >
              <div @click="hideNotifModal()" class="modal-cross-detail">
                <i class="fa fa-times" aria-hidden="true"></i>
              </div>
              <br />
              <span class="notif-time-big">{{
                getNotifDateFormat(currentNotif.created_at)
              }}</span>
            </div>
          </div>
          <!-- notification body -->
          <div class="">
            <div class="row">
              <div class="col-12">
                <span class="notif-detail-page-title" style="font-weight: 500 !important">
                  {{ currentNotif.notification }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- Global Notification modal end -->
    </div>
  </div>
</template>

<script>
import api from "../../../api/notification";
import apis from "../../../api/setterminal.js";
import auth from "../../../api/login.js";
import moment from "moment";
import { db } from "../../../firebaseConfig.js";
export default {
  name: "Header",
  data() {
    return {
      notification_count: 0,
      show_sign_out: false,
      showNotifBody: false,
      currentNotif: {},
      notifications: [],
      terminalName: "Demo Mode",
      showicon: "none",
      user_type: localStorage.getItem("login_user_type"),
      clicks: 0,
      timer: null,
      skip_alert: false,
      go_back: "",
      ongoing_transaction: false,
    };
  },
  methods: {
    //logout function
    logout() {
      var self = this;
      auth
        .employeeLogout()
        .then((response) => {
          if (response.code == 200) {
            self.user_type = null;
            alert(response.message);
            localStorage.removeItem("token");
            localStorage.removeItem("store_user");
            localStorage.removeItem("user_type");
            localStorage.removeItem("terminal_login_response");
            localStorage.removeItem("store_user_type");
            localStorage.removeItem("login_response");
            localStorage.removeItem("view_user");
            localStorage.removeItem("view_terminal");
            delete axios.defaults.headers.common["Authorization"];
            self.$root.$emit("showicon", "none");
            self.$root.$emit("user_type", "");
            self.$bvModal.hide("logout-modal");
            self.$router.push("/employeeLogin").catch((err) => {});
            localStorage.removeItem("login_user_type");
            self.show_sign_out = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //this function enables the notification details section in the notification modal
    showNotifDetails(item) {
      let self = this;

      var request = {
        id: item.id,
        terminal_id:item.terminal_id,
        unique_identification_id:localStorage.getItem("unique_terminal_id")
      };
      api
        .readNotification(request)
        .then(function (response) {
          if (response.code == 200) {
            self.currentNotif = item;
            self.showNotifBody = true;
          }
        })
        .catch(function (error) {});
    },
    showAllNotifications(){
      this.showNotifBody = false;
      this.getNotifications();
    },
    // shows the notification modal
    showNotifModal() {
      this.setdata();
      this.$bvModal.show("notif-modal");
      this.getNotifications();
    },
    // hides the notification modal
    hideNotifModal() {
      this.showNotifBody = false;
      this.$bvModal.hide("notif-modal");
    },
    //returns the notification creation date into a given format
    getNotifDateFormat(notif_date) {
      return moment(notif_date).format("DD MMM YYYY");
    },
    //this function cancels ongoing transaction and redirects to the transaction amount page
    cancelTransaction() {
      if (this.user_type === "Employee") {
        this.clicks++;
        if (this.clicks === 1) {
          var self = this;
          this.timer = setTimeout(function () {
            self.clicks = 0;
          }, 500);
        } else {
          clearTimeout(this.timer);
          if (!this.skip_alert) {
            alert("User canceled the transaction.");
          }
          this.$router.push("/transactionAmount").catch((err) => {});
          this.showicon = "hamburger";
          this.clicks = 0;
        }
      }
    },
    // this function handles the go back functionality
    clickBack() {
      var self = this;
      if (self.ongoing_transaction) {
        return false;
      }
      self.$router.push(self.go_back).catch((err) => {});
      if (!self.skip_alert) {
        alert("User canceled the transaction.");
      }
      if (
        self.$route.name === "ConfirmTotalAmount" ||
        self.$route.name === "ConfirmAmount" ||
        self.$route.name === "EmployeeReLogin" ||
        self.$route.name === "TransactionAmount"
      ) {
        self.showicon = "hamburger";
      }
    },
    // this function calls and api and fetches all the global noticiations
    getNotifications: function () {
      let self = this;
      var request = {
        terminal_id: localStorage.getItem("unique_terminal_id"),
      };
      api
        .getTerminalNotifications(request)
        .then(function (response) {
          if (response.code == 200) {
            self.notifications = response.data;
          } else if (response.code == 401) {
            self.getConfirmation();
          } else {
            alert(response.message);
          }
        })
        .catch(function (error) {});
    },
    // this function handles the drawer visibility
    showDrawer() {
      if (this.showicon == "close") {
        this.showicon = "hamburger";
      } else {
        this.showicon = "close";
      }
      this.$root.$emit("drawer", [""]);
    },
    getdata() {
      let ref = db
        .collection("terminals")
        .doc(localStorage.getItem("unique_terminal_id"));
      ref.get().then((snapshot) => {
        if (snapshot.exists) {
          this.terminals = snapshot.data();
          const containsKey = (obj, key) => Object.keys(obj).includes(key);
          const hasName = containsKey(this.terminals, "notification_count");
          if (hasName == true) {
            if (this.terminals.notification_count == null) {
            } else {
              this.notification_count = this.terminals.notification_count;
            }
          }
        }

        ref.onSnapshot((convo) => {
          let source = convo.metadata.hasPendingWrites ? "Local" : "Server";
          // TODO: add messages to store
          let ref = db
            .collection("terminals")
            .doc(localStorage.getItem("unique_terminal_id"));
          ref.get().then((snapshot) => {
            if (snapshot.exists) {
              this.terminals = snapshot.data();
              const containsKey = (obj, key) => Object.keys(obj).includes(key);
              const hasName = containsKey(this.terminals, "notification_count");
              if (hasName == true) {
                if (this.terminals.notification_count == null) {
                } else {
                  this.notification_count = this.terminals.notification_count;
                  //
                  this.getNotifications();
                }
              }
            }
          });
        });
      });
    },
    // once the notification is read this function updates the firestore collection with null notification count
    setdata() {
      var washingtonRef = db
        .collection("terminals")
        .doc(localStorage.getItem("unique_terminal_id"));
      // Set the "capital" field of the city 'DC'
      return washingtonRef
        .update({
          notification_count: null,
        })
        .then(function () {
          console.log("Document successfully updated!");
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    // this function returns the firestore db collection for further implementations
    firestore() {
      return {
        //terminals: db.collection("terminals"),
      };
    },
    //fetches the current terminal details
    fetchTerminal(token) {
      let self = this;
      var header = {
        "Content-type": "application/json",
        Authorization: token,
      };
      var request = {
        terminal_unique_id: localStorage.getItem("unique_terminal_id"),
      };

      apis
        .getTerminalDetails(request)
        .then((response) => {
          if (response.code == 200) {
            self.$root.$emit("changeTerminalName", response.data.terminal_name);
            localStorage.setItem("terminal_name", response.data.terminal_name);
          } else {
            alert(response.message);
          }
        })
        .catch(function (error) {});
    },
  },
  created() {
    var self = this;
    //this function is used for whenever the page is loaded, this will check if unique terminal id is present in local storage or not
    if (localStorage.getItem("unique_terminal_id") != null) {
      self.terminalName = localStorage.getItem("terminal_name");
    }
    if (
      localStorage.getItem("token") != null &&
      localStorage.getItem("login_user_type") != null
    ) {
      self.showicon = "hamburger";
    }
    if (
      localStorage.getItem("unique_terminal_id") != null &&
      localStorage.getItem("token") != null
    ) {
      self.fetchTerminal(localStorage.getItem("token"));
    }
    self.getdata();
  },
  mounted() {
    var self = this;
    this.$root.$on("changeTerminalName", function (data) {
      self.terminalName = data;
    });
    this.$root.$on("showicon", function (data) {
      self.showicon = data;
    });
    this.$root.$on("user_type", function (data) {
      self.user_type = data;
    });
    this.$root.$on("show_sign_out", function (data) {
      self.show_sign_out = data;
    });
    self.$root.$on("skip_alert", function (data) {
      self.skip_alert = data;
    });
    self.$root.$on("go_back", function (data) {
      self.go_back = data;
    });
    self.$root.$on("ongoing_transaction", function (data) {
      self.ongoing_transaction = data;
    });
  },
};
</script>
<style lang="scss">
#header_container.container {
  width: unset !important;
  max-width: unset !important;
}
</style>
